import {bankLists} from "../config/banksList";

const adapterBankList = () => {
  return bankLists.map(item => ({label: `${item.bank_code} - ${item.bank_name}`, value: item.bank_code}));
};

const findBankData = account => {
  return bankLists.find(bank => Number(bank.bank_code) === account.bank_code);
};

const adapterBankWithAccount = account => {
  return account.map(item => ({label: findBankData(item)?.bank_name, value: item.ID}));
};

const getDataFromAccount = (account, id) => {
  return account.find(item => item.ID === id);
};

export {adapterBankList, adapterBankWithAccount, findBankData, getDataFromAccount};
